import {AmbryKeyActions} from "../const/ActionsConst";
import client from '@common/utils/rest.js'

export const showDialog = (show) => ({
   type: AmbryKeyActions.SHOW_AMBRY_KEY_DIALOG,
   show: show
});

export const updateData = (field, value) => ({
    type: AmbryKeyActions.UPDATE_AMBRY_KEY_DATA,
    field: field,
    value: value
});

export const loadData = () => (dispatch) => {
    client({
        path: 'api/userMaintenance/ambry',
        method: 'GET'
    }).then(
        response => {
            dispatch(dataLoaded(response.entity));
        },
        error => {console.log('Ambry Keys loadData: ', error);}
    )
};

export const saveData = () => (dispatch, getState) => {
    let data = {
        clientId: getState().ambryKey.clientId,
        clientSecret: getState().ambryKey.clientSecret,
        hostAddress: getState().ambryKey.hostAddress,
        grantType: getState().ambryKey.grantType
    };
    client({
        path: 'api/userMaintenance/ambry',
        method: 'POST',
        entity: data
    }).then(
        response => {console.log('AmbryKeys saveData: ', response);},
        error => {console.log('addNewUser: ', error);}
    )
};

export const dataLoaded = (data) => ({
    type: AmbryKeyActions.AMBRY_KEY_LOADED,
    data: data
});